import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { AppUrls } from '../app-urls';
import { DocumentFile } from '../../generated/pricelist/document-file';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private readonly httpBackend: HttpClient;
  private httpHeaders: HttpHeaders;

  constructor(
    private http: HttpClient,
  ) {
    this.httpHeaders = new HttpHeaders({
      accept: '*/*',
    });
  }

  public uploadFile(file): Promise<DocumentFile> {
    const requestParams = new FormData();
    requestParams.append('file', file);

    return this.httpBackend
      .post<DocumentFile>(AppUrls.fileUrls.uploadFileUrl, requestParams, {
        withCredentials: true,
        headers: this.httpHeaders,
      })
      .toPromise();
  }
  /** Аналог uploadFile-метода, на  Observable */
  public fileUpload(file): Observable<DocumentFile> {
    const requestParams = new FormData();
    requestParams.append('file', file);
    return this.httpBackend.post<DocumentFile>(AppUrls.fileUrls.uploadFileUrl, requestParams, {
      withCredentials: true,
      headers: this.httpHeaders,
    });
  }

  public fileInfo(guid: string): Observable<DocumentFile> {
    const url = AppUrls.fileUrls.fileInfo.replace('{0}', guid);
    return this.http.get<DocumentFile>(url);
  }
}
